<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import { getTranslate } from "@utils/getTranslate.js";
	import { openingQuoteMark } from "@core/schema/names/openingQuoteMark.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import type { CourseReview } from "../../courseReviews.js";
	import translations from "./CourseReviewCard.translations.json" with { type: "json" };

	const { review }: { review: CourseReview } = $props();
	const translate = getTranslate(translations);
	const { tenant } = getGlobalTemplateProps();
	const fullTextId = $props.id();

	const openingQuote = openingQuoteMark[tenant.locale];
	let expanded = $state(false);
</script>

<figure class="flex flex-col rounded-2xl bg-white p-6 md:p-8">
	<div aria-hidden="true" class="font-antipol text-fcrorange text-4.5xl/none select-none">{openingQuote}</div>
	<blockquote id={fullTextId} class="grow mt-3 text-sm/normal sm:text-base text-fcrdarkgray">
		{#if expanded}
			<div class="flex flex-col gap-3">
				{#each review.fullText[tenant.locale] as paragraph, index (index)}
					<p><Formatted text={paragraph} /></p>
				{/each}
			</div>
		{:else}
			<Formatted text={review.quote[tenant.locale]} />
		{/if}
	</blockquote>
	<button
		type="button"
		class="self-start mt-3 text-sm/normal text-fcrgray underline transition-colors hover:text-fcrdarkgray"
		aria-expanded={expanded}
		aria-controls={fullTextId}
		onclick={(): void => {
			expanded = !expanded;
		}}
	>
		<Formatted text={translate(expanded ? "showLess" : "readFull")} />
	</button>
	<figcaption class="mt-5 pt-4 border-t border-fcrlightgray-300 font-antipol font-medium text-fcrdarkgray">
		<Formatted text={review.name} />
	</figcaption>
</figure>
